<span
  class="d-flex justify-content-between align-items-center pb-2 mb-3 globalborder-btm-header px-3">
  <span class="col-auto">
    <h2 class="mb-0">Email</h2>
  </span>
  <span *ngIf="isModal">
    <i class="pi pi-times" (click)="closePOEmailModal()"></i>
  </span>
</span>

<div class="adduser-container-hgt px-3">
  <div>
    <jni-display-pdf-frame
      *ngIf="!poEmailScreenStatus"
      [parent]="poEmailForm"
      [poEmailData]="poEmailData"
      [templatesList]="poTemplates"
      (emailSelectionEvent)="emailSelection()"
      [displayRushRevisedSection]="displayRushRevisedSection"
      (base64Pdf)="getBase64ForOrder($event)"
      [isAnyUnCommitLines]="isAnyUnCommitLines"
      (refreshOrderLinesGrid)="refreshOrderLinesGridEvent()"
      [modulewindowState]="windowState">
    </jni-display-pdf-frame>
    <jni-po-email-header
      *ngIf="poEmailScreenStatus"
      [poEmailData]="poEmailData"
      [parent]="poEmailForm"
      [poNumber]="purchaseOrderNumberList"
      [templates]="poTemplates"
      [formErrors]="formErrors"
      [validationMessages]="validationMessages"
      [emailButtonStatus]="emailButtonStatus"
      (fetchVendorInformation)="getVendorInformationForPOEmail($event)"
      (templateSelectedEvent)="templatedSelected($event)"
      (logValidationErrorsEvent)="logValidationErrors()"
      (sendEmailEvent)="sendEmailEvent()"
      (fetchWatermarkedPdf)="fetchWatermarkedPdf($event)"
      [displayRushRevisedSection]="
        displayRushRevisedSection
      "></jni-po-email-header>
  </div>
  <div class="row mb-4">
    <div class="col-md-6">
      <jni-po-email-recipients
        *ngIf="poEmailScreenStatus"
        [recipientsList]="recipientsList"
        (recipientsDeletedEvent)="recipientsDeleted($event)"
        (recipientsAddEvent)="recipientsAdd()"></jni-po-email-recipients>
    </div>
    <div class="col-md-6">
      <jni-po-email-contacts
        *ngIf="poEmailScreenStatus"
        [contactsList]="vendorContacts"
        (addCCEvent)="addCC($event)"
        (addTOEvent)="addTO($event)"></jni-po-email-contacts>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="attachmentsection">
        <jni-po-email-attachments
          *ngIf="poEmailScreenStatus"
          (attachmentFileArrayEvent)="getAttachmentFileArray($event)"
          (TotalFileSizeEvent)="getTotalFileSize($event)"
          (attachmentFileArrayUrlEvent)="attachmentFileUrlArray($event)"
          [fileName]="fileName">
        </jni-po-email-attachments>
      </div>
    </div>
    <div class="col-6">
      <div [hidden]="!poEmailScreenStatus">
        <jni-editor
          [displaySendButton]="displaySendButton"
          #emailComponent
          (sendEmail)="sendEmail($event)"
          [htmlBody]="templateBody"></jni-editor>
      </div>
    </div>
  </div>
</div>
